import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';

import { Heading } from '../../components';

import css from './ListingPage.module.css';
import {
  SCHEMA_TYPE_BOOLEAN,
  SCHEMA_TYPE_DATE,
  SCHEMA_TYPE_ENUM,
  SCHEMA_TYPE_LONG,
} from '../../util/types';

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingFieldConfigs, isFieldForCategory, intl } = props;

  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;
    let publicDataValue = publicData[key];
    let metadataValue = metadata[key];
    if(key.split(".").length > 1) {
      publicDataValue = metadataValue = publicData;
      key.split(".").forEach((k, i) => {
        publicDataValue = publicDataValue[k];
        metadataValue = metadataValue[k];
      });
    }
    const value = typeof publicDataValue != null ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      return schemaType === SCHEMA_TYPE_ENUM
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === SCHEMA_TYPE_BOOLEAN
        ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
        : schemaType === SCHEMA_TYPE_LONG
        ? filteredConfigs.concat({ key, value, label })
        : schemaType === SCHEMA_TYPE_DATE
        ? filteredConfigs.concat({
            key,
            value: intl.formatDate(value, {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
            }),
            label,
          })
        : filteredConfigs;
    }
    return filteredConfigs;
  };

  const existingListingFields = listingFieldConfigs.reduce(pickListingFields, []);

  return existingListingFields.length > 0 ? (
    <section className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </Heading>
      <ul className={css.details}>
        {existingListingFields.map(detail => (
          <li key={detail.key} className={css.detailsRow}>
            <span className={css.detailLabel}>{detail.label}</span>
            <span>{detail.value}</span>
          </li>
        ))}
      </ul>
    </section>
  ) : null;
};

export default SectionDetailsMaybe;
